import React, { useMemo } from 'react';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { Survey } from '../../util';
import { FieldValueUpdate } from '../../util/Survey';
import useLoadAutopopulateData from '../../util/useLoadAutopopulateData';
import { DotLoader } from '@lifeomic/chroma-react/components/DotLoader';

export const useStyles = makeStyles((_theme: Theme) => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
  },
}));

export type SurveyAutopopulateContainerOwnProps = {
  questionnaire: fhir.Questionnaire;
  patientId?: string;
  renderWithAutopopulateValues: (
    autopopulateUpdates: FieldValueUpdate[],
  ) => React.ReactElement;
  className?: string;
};

export type SurveyAutopopulateContainerProps =
  SurveyAutopopulateContainerOwnProps;

const SurveyAutopopulateContainer: React.FC<
  SurveyAutopopulateContainerProps
> = ({ questionnaire, patientId, renderWithAutopopulateValues }) => {
  const survey = useMemo(() => new Survey(questionnaire), [questionnaire]);
  const { isLoading, valueUpdates } = useLoadAutopopulateData({
    survey,
    patientId,
  });
  const classes = useStyles({});

  if (isLoading)
    return (
      <div className={classes.root}>
        <DotLoader size={0} />
      </div>
    );

  return renderWithAutopopulateValues(valueUpdates);
};

export default React.memo(SurveyAutopopulateContainer);
